import styled from 'styled-components';

// Note: Le padding non-symétrique est nécessaire car le texte est toujours en majuscule et
// n'occupe que la partie "haute" de la police, laissant du vide en bas. Pour compenser, la
// marge du haut est plus grande que celle du bas (le vide du texte complétant le manquant)
// Bonus: On pourrait utiliser `text-box-edge: cap` mais le support actuel est inexistant
// -> https://developer.mozilla.org/en-US/docs/Web/CSS/text-box-edge
export const Container = styled.span`
  display: inline-block;
  border-radius: 4px;
  padding: 3px 4px 1px;

  overflow: hidden;
  text-overflow: ellipsis;

  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
  white-space: nowrap;
  text-transform: uppercase;
`;
